import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press5',
  templateUrl: './notice-press5.component.html',
  styleUrls: ['./notice-press5.component.scss']
})
export class NoticePress5Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
